import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material"
import { useEffect } from "react"
import { useLocation, useNavigate, useRouteError } from "react-router-dom"
import { clearAuthAndRedirect } from "../controllers/accounts/auth"

export const ErrorPage = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const routeError = useRouteError()

    const errorMessage = routeError instanceof Error
      ? routeError.message
      : typeof routeError?.data === 'string'
        ? routeError.data
        : routeError?.statusText || ''

    const isUserStateError = /(?:user|userdetails|account).*(?:undefined|null)|(?:undefined|null).*(?:user|userdetails|account)|cannot read properties of undefined/i.test(String(errorMessage))
    const redirectPath = isUserStateError ? '/login' : '/'

    useEffect(() => {
      if (isUserStateError) {
        clearAuthAndRedirect('/login')
        return
      }

      const timer = window.setTimeout(() => {
        navigate(redirectPath, { replace: true })
      }, 2500)

      return () => window.clearTimeout(timer)
    }, [isUserStateError, navigate, redirectPath])
    
    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          minHeight: '100vh',
          justifyContent: 'center',
          px: 2,
          background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)',
        }}
      >
        <Stack spacing={2} sx={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
          <CircularProgress sx={{ alignSelf: 'center' }} />
          <Typography variant="h4">Something went wrong</Typography>
          <Typography color="text.secondary">
            {isUserStateError
              ? 'Your session is no longer valid. Signing you out and sending you to login.'
              : `This page could not be loaded${location?.pathname ? `: ${location.pathname}` : ''}. Redirecting now.`}
          </Typography>
          {errorMessage ? <Alert severity="error">{errorMessage}</Alert> : null}
          <Button variant="contained" onClick={() => navigate(redirectPath, { replace: true })}>
            Go now
          </Button>
        </Stack>
      </Box>
    )
}